// Learn pages are pure static HTML with the CSS bundle already linked in
// <head>. This tiny entry only wires up the CMP banner, the "Cookie
// settings" button in the inline footer, the consent-gated AdSense loader,
// and the visit beacon — no CSS imports, no calculator UI.
import { trackEvent } from "../analytics";
import { installConsent } from "../consent";
import { loadAdSenseOnConsent } from "../ads/adsense";

// REN-83: every article and metro page used to emit nothing, so the entire
// ad-bearing and SEO surface was invisible while only the ad-free home page
// was measured. The event carries its own path, so `/learn/` and each
// article land in their own analytics row.
trackEvent("visit");

const consent = installConsent();

document
  .querySelectorAll<HTMLButtonElement>('[data-action="open-consent"]')
  .forEach((btn) => {
    btn.addEventListener("click", () => consent.openSettings());
  });

loadAdSenseOnConsent({ consent });
